import React from "react";
import { generatePostDrawingUrl } from "utility";
import { Orientation } from "utility/constants";
import Image from "next/image";

export default function DrawingPost({ post }) {
  // Portrait drawings
  if (
    post.contentOrientation === Orientation.PORTRAIT ||
    post.contentOrientation === Orientation.PORTRAIT_UPSIDE_DOWN
  ) {
    const postUrl = generatePostDrawingUrl({
      post,
      edits: {
        resize: { width: 1200, fit: "cover", strategy: "attention" },
      },
    });
    return (
      <Image
        width={100}
        height={100}
        quality={100}
        src={`${postUrl}`}
        className="h-screen max-w-full w-full md:w-auto lg:mx-auto overflow-hidden"
        alt=""
      />
    );
  }

  // Landscape drawings
  const imageRotation = {
    [Orientation.LANDSCAPE_LEFT]: 90,
    [Orientation.LANDSCAPE_RIGHT]: -90,
  };

  const rotate = imageRotation[post.contentOrientation];
  const postUrl = generatePostDrawingUrl({
    post,
    edits: {
      ...(rotate ? { rotate } : undefined),
      resize: { width: 340, fit: "cover", strategy: "attention" },
    },
  });

  return (
    <Image
      height={100}
      width={100}
      quality={100}
      className="object-cover h-screen max-w-full w-full md:w-auto lg:mx-auto overflow-hidden"
      src={postUrl}
      alt={post?.title}
    />
  );
}
